module.exports = __webpack_public_path__ + "img/MS_Startups_Celebration_Badge_Dark.51cb3384.webp";